import React from 'react';


// Radio input
const RadioButton = ({
  field: { name, value, onChange, onBlur },
  form,
  selectedValue,
  label,
  className,
  id,
  ...props
}) => {
  // cast string representation of bool to bool
  if(['true','false'].includes(value)) {
    value = value === 'true' ? true : false;
  }
  return (
    <div>
      <label htmlFor={name}>
        <input
          name={name}
          id={id ? id : name+selectedValue}
          type="radio"
          value={selectedValue} // could be something else for output?
          checked={selectedValue === value}
          onChange={onChange}
          onBlur={onBlur}
          className="radio-button"
        />
        {label}
      </label>
    </div>
  );
};

export default RadioButton;


// WEBPACK FOOTER //
// ./src/modules/form/components/input/RadioButton.jsx